import React, { useCallback, useEffect, useState } from 'react';

let logoutTimer;

const AuthContext = React.createContext({
  token: '',
  isLoggedIn: false,
  login: (token) => {},
  logout: () => {},
  name: '',
  email: '',
});

const calculateRemainigTime = (expiryDate) => {
  const currentTime = new Date().getTime(); // we get the present time
  const adjExpirationTime = new Date(expiryDate).getTime(); // time in milliseconds in future

  const remainingTime = adjExpirationTime - currentTime; // time in milliseconds remaining

  return remainingTime;
};

const retrieveToken = () => {
  const storedToken = localStorage.getItem('token');
  const storedExpirationTime = localStorage.getItem('expiryDate');

  const remainingTime = calculateRemainigTime(storedExpirationTime);

  if (remainingTime <= 60000) {
    // if less than 1 minute, '60000 millisec is 1 minute'
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('expiryDate');
    return null;
  }

  // if we make past the above if check then there is enough time available so we will return
  //the token and the duration
  return {
    token: storedToken,
    duration: remainingTime,
  };
};

export const AuthContextProvider = (props) => {
  const tokenData = retrieveToken();
  const initailToken = tokenData ? tokenData.token : '';
  const [token, setToken] = useState(initailToken);

  const userIsLoggedIn = !!token;

  const logoutHandler = useCallback(() => {
    setToken(null);

    localStorage.removeItem('token');
    localStorage.removeItem('expiryDate');
    localStorage.removeItem('userId');

    if (logoutTimer) {
      clearTimeout(logoutTimer); // clear the timer
    }
  }, []);

  const loginHandler = (token, expirationTime) => {
    setToken(token);

    localStorage.setItem('token', token);
    localStorage.setItem('expiryDate', expirationTime);

    const remainigDuration = calculateRemainigTime(expirationTime);

    logoutTimer = setTimeout(logoutHandler, remainigDuration);
  };

  useEffect(() => {
    if (tokenData) {
      // console.log("tokenData duration", tokenData.duration);
      logoutTimer = setTimeout(logoutHandler, tokenData.duration);
    }
  }, [tokenData, logoutHandler]);

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
    name: '',
    email: '',
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
